import clsx from 'clsx'
import { BarMultiSelect } from 'components/barMultiSelect'
import { listDays } from 'lib'
import React from 'react'
import { formatLocalTime } from 'utils'
import { TitleContentRecurrenceProps } from './types'

export const TitleContentRecurrence: React.FC<TitleContentRecurrenceProps> = ({
	type,
	expire,
	publish,
	endTitle,
	recurrent,
	endsRecurrent,
	publishRecurrent,
	listDaysRecurrence,
	repeatEveryRecurrent,
	event,
	showGrayLine
}) => {
	const className = 'text-[15px] text-gray-18 font-normal font-Inter'
	const classNameTitle =
		'text-[15px] text-blue-primary font-bold font-Inter pb-3'
	if (type === 'event' && event?.event_start_date && event?.event_end_date) {
		return (
			<div className="flex flex-col">
				<p className={classNameTitle}>
					{event.event_recurrence ? 'Event Recurrence' : 'Event Schedule'}
				</p>
				<div className="flex flex-col items-start">
					<div className="flex items-center gap-2">
						<p className={clsx(className, 'font-bold')}>Event date and time:</p>
						<p>
							{formatLocalTime(event.event_start_date, 'MM/DD/YYYY h:mm A')}
						</p>
					</div>
					<div className="flex items-center gap-2">
						<p className={clsx(className, 'font-bold')}>Event Ends at:</p>
						<p>{formatLocalTime(event.event_end_date, 'MM/DD/YYYY h:mm A')}</p>
					</div>
					{event.event_recurrence && (
						<div className="flex items-center gap-2">
							<p className={clsx(className, 'font-bold')}>
								Event repeats until:
							</p>
							<p>
								{formatLocalTime(event.event_recurrence, 'MM/DD/YYYY h:mm A')}
							</p>
						</div>
					)}
				</div>
			</div>
		)
	}

	return (
		<div className="flex flex-col">
			{type === 'content' && (
				<p className={classNameTitle}>
					Content Item {recurrent ? 'Recurrence:' : 'Schedule:'}
				</p>
			)}

			<div
				className={clsx(
					'flex items-center gap-2',
					showGrayLine && 'border-r border-gray-19 pr-7',
					event?.event_recurrence && 'min-h-[67px]'
				)}
			>
				<div>
					<p className={clsx(className, 'font-bold')}>
						{type === 'content' ? 'Content' : 'Push'}
					</p>
					<p className={clsx(className, 'font-bold')}>
						{recurrent ? 'Recurrence:' : 'Schedule:'}
					</p>
				</div>
				<div>
					{!recurrent ? (
						<div>
							<p className={className}>Publish: {publish}</p>
							{expire && <p className={className}>Expire: {expire}</p>}
						</div>
					) : (
						<div className="flex items-center border border-blue-primary rounded-[32px] px-4 py-1">
							<div className="p-2 border-r border-blue-primary">
								<p className={className}>Publish:</p>
								<p className={className}>{publishRecurrent}</p>
							</div>
							<div className="p-2 border-r border-blue-primary">
								<p className={className}>Repeat every:</p>
								<p className={clsx(className, 'capitalize')}>
									{repeatEveryRecurrent}
								</p>
							</div>
							{listDaysRecurrence && (
								<div className="p-2 border-r border-blue-primary">
									<p className={className}>Repeats on:</p>
									<BarMultiSelect
										list={listDays}
										audieceConfirmation={false}
										listSeleted={listDaysRecurrence}
										isDisabled
									/>
								</div>
							)}
							<div className="p-2">
								<p className={className}>Ends {endTitle}:</p>
								<p className={className}>{endsRecurrent}</p>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	)
}
